import { useEffect, useState } from 'react';
import { ResponseException } from '../models';

import { AxiosPublic } from '../utils/axios';

export const useActivateUser = () => {
  const [isFetching, setFetching] = useState(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [successPasswordSet, setSuccessPasswordSet] = useState<boolean>(false);
  const [errors, setErrors] = useState<string[]>([]);
  const [displayErrors, setDisplayErrors] = useState(false);

  useEffect(() => {
    setDisplayErrors(!isFetching && !success && errors.length > 0);
  }, [isFetching, success, errors]);

  const submit = async (activationCode: string) => {
    try {
      setFetching(true);
      await AxiosPublic.post(`/users/activate/register/${activationCode}`);
      setSuccess(true);
    } catch (e) {
      setErrors(new ResponseException(e).getErrorMessage());
      setSuccess(false);
    } finally {
      setFetching(false);
    }
  };

  const retrieveActivation = async (activationCode: string) => {
    try {
      setFetching(true);
      await AxiosPublic.get(`/users/activate/${activationCode}`);
      setSuccess(true);
      setErrors([]);
    } catch (e) {
      setErrors(new ResponseException(e).getErrorMessage());
      setSuccess(false);
    } finally {
      setFetching(false);
    }
  };

  const setPassword = async (values: any) => {
    try {
      setFetching(true);
      await AxiosPublic.post(`/users/activate/password`, values);
      setSuccessPasswordSet(true);
      setErrors([]);
    } catch (e) {
      setErrors(new ResponseException(e).getErrorMessage());
      setSuccessPasswordSet(false);
    } finally {
      setFetching(false);
    }
  };

  return {
    isFetching,
    success,
    successPasswordSet,
    errors,
    displayErrors,
    submit,
    retrieveActivation,
    setPassword,
  };
};
